import React from 'react'
import { useNavigate } from 'react-router-dom'
import backIcon from './../assets/image/Back-Icon.svg'

const BackButton = (props) => {

        const navigate = useNavigate();
        
    
    return (
        <>
        
            <img src={backIcon}  style={{ cursor: "pointer" , marginLeft:"10px", marginRight:"25px", marginBottom:  "5px" }}onClick={()=>navigate(-1) } alt="" />
        </>
    )
}

export default BackButton